module.exports = __webpack_public_path__ + "static_portal/media/cycle_video_steve_hq.0b9b2686.mp4";